import React from 'react'
import styled from 'styled-components'
import {
  AnimatedSection,
  fadeInUp,
  scaleIn,
  floatUp,
} from './animations/AnimatedSection'

const FutureImpactSection = () => {
  return (
    <Section>
      <Container>
        <HeaderStack>
          <AnimatedSection variants={scaleIn}>
            <LogoSymbol src="/images/logos/Logo-Symbol.svg" alt="Logo Symbol" />
          </AnimatedSection>
          <AnimatedSection variants={fadeInUp} delay={0.1}>
            <Title>
              The Future of <Highlight>Impact</Highlight> is Being Built
            </Title>
          </AnimatedSection>
          <AnimatedSection variants={fadeInUp} delay={0.2}>
            <Subtitle>
              17 Sustainable Development Goals. One Unified Action Platform.
            </Subtitle>
          </AnimatedSection>
        </HeaderStack>

        <AnimatedSection variants={floatUp} delay={0.2} threshold={0.1}>
          <ImageWrapper>
            <DashboardImage
              src="/images/homepage-new/dashboard.webp"
              alt="Dashboard Preview"
            />
          </ImageWrapper>
        </AnimatedSection>

        <FooterStack>
          <AnimatedSection variants={scaleIn} delay={0.1}>
            <SDGLogo src="/images/homepage-new/sdg.webp" alt="SDG Logo" />
          </AnimatedSection>
          <AnimatedSection variants={fadeInUp} delay={0.2}>
            <FooterSubtitle>
              17 Sustainable Development Goals. One Unified Action Platform.
            </FooterSubtitle>
          </AnimatedSection>
        </FooterStack>
      </Container>
    </Section>
  )
}

const Section = styled.section`
  width: 100%;
  padding: 96px 0;
  background: url('/images/paperboard-texture.webp'), #f8f7f0;
  background-blend-mode: multiply, normal;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;

  @media (max-width: 768px) {
    padding: 64px 0;
  }
`

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 72px;
  width: 100%;
  max-width: 1283px;
  padding: 0 40px;
  box-sizing: border-box;
`

const HeaderStack = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  width: 100%;
  max-width: 789px;
`

const LogoSymbol = styled.img.attrs({ loading: 'lazy' })`
  width: 39.58px;
  height: auto;
  object-fit: contain;
`

const Title = styled.h2`
  font-family: 'Poppins', sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 48px;
  line-height: 56px;
  text-align: center;
  letter-spacing: -0.04em;
  color: #2a2a2a;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 32px;
    line-height: 40px;
  }
`

const Highlight = styled.span`
  background: linear-gradient(90deg, #0e6409 0%, #bbe148 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  color: transparent;
`

const Subtitle = styled.p`
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: #5e5e5e;
  margin: 0;
`

const ImageWrapper = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 12.6px;
  width: 100%;
  max-width: 789px;
  background: #f3f3f3;
  border-width: 1px 4px 4px 1px;
  border-style: solid;
  border-color: #2a2a2a;
  box-shadow: 0px 31px 62px -12px rgba(0, 0, 0, 0.15);
  border-radius: 10px;
`

const DashboardImage = styled.img.attrs({ loading: 'lazy' })`
  width: 100%;
  height: auto;
  border-radius: 0px;
  display: block;
`

const FooterStack = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  width: 100%;
  max-width: 484px;
`

const SDGLogo = styled.img.attrs({ loading: 'lazy' })`
  width: 100%;
  max-width: 358px;
  height: auto;
  object-fit: contain;
`

const FooterSubtitle = styled.p`
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: #5e5e5e;
  margin: 0;
`

export default FutureImpactSection
